import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Logo from './components/NavbarCore/Logo';
import NavigationLinks from './components/NavbarCore/NavigationLinks';
import MenuButton from './components/NavbarButtons/MenuButtons';
import AuthButtons from './components/NavbarButtons/AuthButtons';
import UserMenu from './components/NavbarButtons/UserMenu';
import LoginMenu from './components/NavbarDropdowns/LoginMenu';
import PricingMenu from './components/NavbarDropdowns/PricingMenu';
import MobileMenu from './components/NavbarDropdowns/MobileMenu';

const SCROLL_THRESHOLD = 80;
// Routes where the nav stays pinned at the top (no scroll-morph to floating pill)
const FREEZE_MORPH_ROUTES = ['/submissions'];

const Navbar = () => {
 const location = useLocation();
 const freezeMorph = FREEZE_MORPH_ROUTES.some((r) => location.pathname.startsWith(r));

 const [activeMenu, setActiveMenu] = useState(null);
 const [showUserMenu, setShowUserMenu] = useState(false);
 const [scrolledRaw, setScrolledState] = useState(false);
 const userMenuRef = useRef(null);
 const [isAuthenticated, setIsAuthenticated] = useState(
   window.djangoContext?.isAuthenticated || false
 );

 // When morph is frozen, force `scrolled` to false so the nav stays at top
 const scrolled = freezeMorph ? false : scrolledRaw;

 useEffect(() => {
   if (freezeMorph) return; // skip listener on frozen routes
   const handleScroll = () => {
     setScrolledState(window.scrollY > SCROLL_THRESHOLD);
   };
   window.addEventListener('scroll', handleScroll, { passive: true });
   handleScroll();
   return () => window.removeEventListener('scroll', handleScroll);
 }, [freezeMorph]);

 const openMenu = (menuName) => {
   setActiveMenu(activeMenu === menuName ? null : menuName);
 };

 return (
   <>
     {/* Spacer — reserves space when nav is at top */}
     <div className="h-14" />

     <MobileMenu
       isOpen={activeMenu === 'mobile'}
       isAuthenticated={isAuthenticated}
       setActiveMenu={setActiveMenu}
       scrolled={scrolled}
     />
     <LoginMenu isOpen={activeMenu === 'login'} scrolled={scrolled} />
     <PricingMenu isOpen={activeMenu === 'pricing'} scrolled={scrolled} />

     <div
       className={`fixed left-0 right-0 z-50 transition-all duration-300 ease-out ${
         scrolled
           ? 'bottom-4 max-w-7xl mx-auto px-4'
           : 'top-0'
       }`}
     >
       <div
         className={`bg-white-pure px-6 transition-all duration-300 ease-out ${
           scrolled
             ? 'border-[1.5px] border-white-ash rounded-full'
             : 'border-b border-white-ash'
         }`}
       >
         <div className="flex items-center justify-between h-14">
           <div className="flex items-center gap-8">
             <Logo />
             <NavigationLinks />
           </div>

             <div className="flex items-center">
                 {isAuthenticated ? (
                     <UserMenu
                         isOpen={showUserMenu}
                         onToggle={() => setShowUserMenu(!showUserMenu)}
                         onClose={() => setShowUserMenu(false)}
                     />
                 ) : (
                     <AuthButtons
                         onLoginClick={() => openMenu('login')}
                         onPricingClick={() => openMenu('pricing')}
                     />
                 )}

                 <div className="flex items-center md:hidden ml-4">
                     {!isAuthenticated && (
                         <button
                             onClick={() => openMenu('login')}
                             className="text-small-sm font-bold mr-4 text-ink-light"
                         >
                             Sign In
                         </button>
                     )}
                     <MenuButton
                         isOpen={activeMenu === 'mobile'}
                         onClick={() => openMenu('mobile')}
                     />
                 </div>
             </div>
         </div>
       </div>
     </div>
   </>
 );
};

export default Navbar;
